import { TextCell } from "@silevis/reactgrid";
import { ICellTypeHandler } from "components/grecoreactgrid/ICellTypeHandler";
import { ClearedAmountAllCellTemplate } from "../customcells/ClearedAmountAllCellTemplate";

class ClearedAmountAllCellTypeHandler implements ICellTypeHandler {
  cellType = "clearedamountall";
  isCustom = true;
  instance = new ClearedAmountAllCellTemplate();
  determineNewValue = (change: any) => {
    return (change.newCell as TextCell).text;
  };
  getEntryRow = (
    entry: any,
    columnConfig: any,
    rowsMetadataMap: any,
    keyColumn: string,
    context: {
      [key: string]: any;
    }
  ) => {
    const { sort, setSort, t } = context;

    const [
      { clUnsettledPaymentPlans },
      { setRemindersCreateDialogStoreValue },
    ] = context["remindersStore"];

    return {
      type: "clearedamountall",
      value: "remindersClearedAmountAll",
      selected: rowsMetadataMap[entry[keyColumn]]?.selected ?? false,
      highlighted: rowsMetadataMap[entry[keyColumn]]?.highlighted ?? false,
      sortFn: (key, dir) => {
        setSort({
          key: columnConfig.columnId,
          dir: dir,
        });
      },
      key: columnConfig.columnId,
      sort: sort,
      sortable: columnConfig.sortable,
      onSelectAllFn: () => {
        const updatedPlans = clUnsettledPaymentPlans.map((plan) => {
          const premiumDebt = plan.premiumDebt;
          const suggestedPaymentAmount =
            Math.round(premiumDebt * 100) / 100;
          return { ...plan, suggestedPaymentAmount };
        });
        setRemindersCreateDialogStoreValue(
          "clUnsettledPaymentPlans",
          updatedPlans
        );
      },
      onClearAllFn: () => {
        setRemindersCreateDialogStoreValue(
          "clUnsettledPaymentPlans",
          clUnsettledPaymentPlans.map((plan) => {
            return { ...plan, suggestedPaymentAmount: 0 };
          })
        );
      },
      t,
    };
  };
}

export default ClearedAmountAllCellTypeHandler;
